var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comBox"},[_c('div',{staticClass:"box-header",class:{borderB: _vm.bder}},[_c('div',[_vm._t("name")],2),_c('div',[_vm._t("other")],2)]),_c('div',{staticClass:"box-content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }